import { shallowEqual, useSelector } from 'react-redux';
import type { LocationState } from 'redux-first-router';
import {
  ROUTE_COMPANY,
  ROUTE_COMPANY_WITH_EVENTS,
  ROUTE_COMPARE_COMPANY,
  ROUTE_COMPARE_HOME,
} from '@/constants/routes';
import { useCompareCompanyId } from '@/pages/CompanyReport/components/CompareCompanies/CompanyIDProvider';

export function useCompanyCanonicalUrl() {
  const compareId = useCompareCompanyId();
  const canonicalUrl = useSelector<{ location: LocationState }, string>(
    (state) => {
      if (
        [ROUTE_COMPANY, ROUTE_COMPANY_WITH_EVENTS].includes(state.location.type)
      ) {
        const { isoCode2, industry, exchange_ticker, companyname } =
          state.location.payload;
        return `/stocks/${isoCode2}/${industry}/${exchange_ticker}/${companyname}`;
      }
      //TODO: @victorc make this work for compare pages
      /** I got your back Victor C */
      if (
        [ROUTE_COMPARE_COMPANY, ROUTE_COMPARE_HOME].includes(
          state.location.type
        )
      ) {
        try {
          if (typeof compareId === 'string' && compareId !== '') {
            return compareId;
          }
          const { symbols } = state.location.payload;
          const safeSymbols = decodeURIComponent(symbols);
          return safeSymbols;
        } catch {
          return '';
        }
      }
      console.warn(
        'useCompanyCanonicalUrl cannot be used outside company or compare pages'
      );
      return '';
    },
    shallowEqual
  );
  return canonicalUrl;
}
